type ImprovePromptAbortController = {
  abort: () => void;
};

const abortControllers = new Map<string, ImprovePromptAbortController>();

export const setImprovePromptAbortController = (chatId: string, controller: ImprovePromptAbortController) => {
  abortControllers.set(chatId, controller);
};

export const getImprovePromptAbortController = (chatId: string): ImprovePromptAbortController | null => {
  return abortControllers.get(chatId) ?? null;
};

export const clearImprovePromptAbortController = (chatId: string) => {
  abortControllers.delete(chatId);
};
